<template>
    <section class="section__title">
        <v-container >
            <v-row>
                <v-col>
                    <p>山武市立松尾中学校は山武市立蓮沼中学校と統合し、令和４年度より山武望洋中学校として新たにスタートします。校舎は現在と変わりませんが、松尾中学校は今年度で閉校を迎えます。閉校を記念して、普段校舎の様子をを見ることが難しい保護者を始めとする地域の方々が、松尾中学校を思い出すきっかけを作りたいと思い、本HPを作成しました。松尾中学校の思い出をこのHPで是非振り返ってみてください</p>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>

export default {
    name : "HomeStart",
}
</script>

<style scoped lang='scss'>
.section__title {
    // @media screen and (min-width: 771px) and (max-width: 900px) {
    //     margin-top: -20px !important;
    // }
    @media screen and (min-width: 701px) and (max-width: 770px) {
        margin-top: -10px !important;
    }
    @media screen and (min-width: 600px) and (max-width: 700px) {
        margin-top: -30px !important;
    }
    @media screen and (min-width: 501px) and (max-width: 599px) {
        margin-top: -100px !important;
    }
    @media screen and (max-width: 500px)  {
        margin-top: -180px !important;
    }
}
</style>
